<h2 mat-dialog-title>Modificar saldo del club</h2>
<mat-dialog-content style="min-width: 400px; min-height: 100px">
  <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Valor</mat-label>
      <input
        formControlName="valorEdicion"
        matInput
        placeholder="Valor a sumar o restar"
        type="number"
      />
      <mat-hint style="font-size: xx-small;
      line-height: normal;"
        >Valores positivos suman al saldo actual, valores negativos restan al
        saldo actual</mat-hint
      >
    </mat-form-field>
  <br><br>
    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Descripción</mat-label>
      <textarea
        formControlName="descripcion"
        matInput
        placeholder="Descripción del movimiento"
        type="text"
      ></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button 
  *ngIf="muestraBtnGuardar"
    type="submit"
    mat-button
    mat-flat-button
    color="primary"
    (click)="guardar()"
    [disabled]="registerForm.invalid"
  >
    Guardar
  </button>
  <button mat-button mat-dialog-close="false">Cancelar</button>
</mat-dialog-actions>

<!-- mat-dialog-close='false' -->
